import PropTypes from 'prop-types';
export var ComponentPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.element]);
export var ChildrenPropType = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]);